export default __webpack_public_path__ + "static/dummy-graph-casestudy-ad283a898dad41080a97d07522a0c5e6.png";